import { useAuth } from 'context/AuthContext'
import React from 'react'
import * as S from './styles'

const statusColors = {
  away: 'yellow',
  online: 'green',
  offline: 'gray',
  busy: 'red',
  undefined: 'green',
}

export default function Profile() {
  const { user } = useAuth()
  return (
    <S.ProfileContainer statusColor={statusColors[user.status]}>
      <div>
        <h1>Mi perfil</h1>
      </div>

      <S.SectionBoxes>
        <S.SectionBox>
          <h2>Información Personal</h2>
          {user?.firstName && (
            <S.InfoItem>
              <span>
                Nombre:
                {' '}
                {user?.firstName}
              </span>
            </S.InfoItem>
          )}
          {user?.lastName && (
            <S.InfoItem>
              <span>
                Apellido:
                {' '}
                {user.lastName}
              </span>
            </S.InfoItem>
          )}
          {user?.address && (
            <S.InfoItem>
              <span>
                Dirección:
                {' '}
                {user?.address}
              </span>
            </S.InfoItem>
          )}
        </S.SectionBox>
        <S.SectionBox>
          <h2>Contacto</h2>
          {user?.telephone && (
            <S.InfoItem>
              <span>
                Telefono:
                {' '}
                {user?.telephone}
              </span>
            </S.InfoItem>
          )}
          <S.InfoItem>
            {user?.email && (
            <span>
              Email:
              {' '}
              {user?.email}
            </span>
            )}
          </S.InfoItem>
        </S.SectionBox>
      </S.SectionBoxes>
    </S.ProfileContainer>
  )
}
